import React from "react";
import BasicModal from "../../ui/BasicModal/BasicModal";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import VerificationCodeInput from "../../shared/VerificationCodeInput";
import { Button, Col, Row, Spin } from "antd";

import "./VerificationCodeModal.scss";

const VerificationCodeModal = ({
   children,
   isVisible,
   onCancel,
   onComplete,
   isLoading,
   email,
   updateType
}) => {
   return (
      <BasicModal isModalOpen={isVisible} onCancel={onCancel} footerButtonCustomStyle>
         <div className="mt-5 mb-8 text-center">
            <h4>Confirmation code</h4>
            <img src={toAbsoluteUrl("/media/bg/update-email-password.png")} alt="" height={100} />
            <p className="mt-8 mb-5 description">
               We have sent a verification code to <span>{email}</span> to confirm your email update
               request. Please enter the code in the fields below to complete the process. Once
               verified, your {`${updateType === "email" ? "email" : "password"}`} will be
               successfully updated.
            </p>
            <VerificationCodeInput onComplete={onComplete} />
            <Row gutter={16} className="my-12" justify="center" align="middle">
               <Col>
                  <Button className="cancel" onClick={onCancel} disabled={isLoading}>
                     Cancel
                  </Button>
               </Col>
               <Col>
                  <Spin spinning={isLoading}></Spin>
               </Col>
            </Row>
            {children}
         </div>
      </BasicModal>
   );
};

export default VerificationCodeModal;
